import styled from 'styled-components'

const WrapDiv = styled.div<{ vertical?: string }>`
  ${({ vertical }) => {
    return { paddingBottom: vertical || 0 }
  }}
`

const WrapSpan = styled.span<{ horizontal?: string }>`
  ${({ horizontal }) => {
    return { paddingLeft: horizontal || 0 }
  }}
`

export { WrapDiv, WrapSpan }
